module.exports = __webpack_public_path__ + "img/owiwi-partner.ddf1731e.png";